import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { socket } from '../../socket';

import { IconSettings, Button, Card, Modal } from '@salesforce/design-system-react';
import CustomToastContainer from '../../Components/App/CustomToastContainer';
import PageBlockHeader from '../../Components/PageBlockHeader';
import MilestoneConnectorBar from '../../Components/MilestoneConnectors/MilestoneConnectorBar';
import ConnectorInput from '../../Components/MilestoneConnectors/ConnectorInput';
import ConnectorList from '../../Components/MilestoneConnectors/ConnectorList';
import ConnectorInstructions from '../../Components/Sidebars/Instructions/ConnectorInstructions';
import VidyardEmbed from '@vidyard/embed-code';
import Sidebar from '../../Components/Sidebars/App/Sidebar';
import PotentialConnectors from '../../Components/MilestoneConnectors/PotentialConnectors';
import Banner from '../../Components/App/Banner';
import AddIdea from '../../Components/AddIdea';

import {
  addToast,
  setStepId,
  addMilestoneConnectorDBOnly,
  addMilestoneConnector,
  updateMilestoneConnectorDBOnly,
  updateMilestoneConnector,
  deleteMilestoneConnectorDBOnly,
  deleteMilestoneConnector,
  updateMilestoneConnectorOrderDBOnly,
  updateMilestoneConnectorOrder,
  addIdeaDBOnly,
  addIdea,
  selectIdeaDBOnly,
  selectIdea,
  updateIdeaDBOnly,
  updateIdea,
  deleteIdeaDBOnly,
  deleteIdea,
} from '../../actions';

let connectorFormatted = {
  trigger: 'trigger',
  guide: 'guide',
  key: 'keyVar',
  crisis: 'crisis',
  triumph: 'triumph',
};

function useToggle(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);

  const toggle = React.useCallback(() => {
    setValue(v => !v);
  }, []);

  return [value, toggle];
}

const MilestoneConnectors = (props) => {
  const [currentMilestone, setCurrentMilestone] = useState('trigger');
  const [nextMilestone, setNextMilestone] = useState('guide');
  const [milestoneStep, setMilestoneStep] = useState(1);
  const [milestones, setMilestones] = useState(['trigger', 'guide', 'key', 'crisis', 'triumph']);
  const [content, setContent] = useState('');
  const [ideaId, setIdeaId] = useState(null);
  const [editing, setEditing] = useState(false);
  const [isIdeaOpen, setIsIdeaOpen] = useToggle();
  const [isConnectorOpen, setIsConnectorOpen] = useToggle();
  const [connectorId, setConnectorId] = useState(null);
  const [connectorTitle, setConnectorTitle] = useState('');
  const [connectorContent, setConnectorContent] = useState('');

  useEffect(() => {
    VidyardEmbed.api.renderDOMPlayers();
    socket.emit('onAddActiveCollaboratorServer',{ "journeyId": props.journeyId, "email": props.username } );
  }, []);

  const openEditIdea = (id, content) => {
    setEditing(true);
    setContent(content);
    setIdeaId(id);
    setIsIdeaOpen();
  }

  const closeAddIdea = () => {
    setIsIdeaOpen()
    setEditing(false);
    setIdeaId(null);
    setContent('');
  }

  const handleIdeaActions = async (ideaId, action, connectorName, content, chosen) => {
    if (action === 'Delete') {
      await props.deleteIdeaDBOnly(null, connectorName, ideaId);
    } else if (action === 'Select') {
      if (currentMilestone === "key") {
        await props.addMilestoneConnectorDBOnly(props.journeyId, "keyVar", "Add Connector Title", content);
      } else {
        await props.addMilestoneConnectorDBOnly(props.journeyId, currentMilestone, "Add Connector Title", content);
      }

      await props.deleteIdeaDBOnly(null, connectorName, ideaId);
   } else if (action === 'Save') {
      await props.updateIdeaDBOnly(null, ideaId, connectorName, content);
    } 
  };

  const handleDropdownSelect = (ideaId, action, connector, title, content) => {
    if(action === "Delete"){
      props.deleteMilestoneConnectorDBOnly(ideaId, connector);
    } else if (action === "Up") {
      reorderConnector(ideaId, connector, -1);
    } else if (action === "Down") {
      reorderConnector(ideaId, connector, 1);
    } else if (action === "Save") {
      if (title === undefined || title === "" || content === undefined || content === ""){
        props.addToast({ labels: { heading: 'Please make sure your idea has content.' }, variant: 'error' });
      } else {
        if (currentMilestone === "key") {
          props.updateMilestoneConnectorDBOnly("keyVar", ideaId, title, content);
        } else {
          props.updateMilestoneConnectorDBOnly(connector, ideaId, title, content);
        }
        setIsConnectorOpen();
        setConnectorContent('');
        setConnectorTitle('');
        setConnectorId(null);
      }
    } else if (action === "Edit") {
      setIsConnectorOpen();
      setConnectorContent(content);
      setConnectorTitle(title);
      setConnectorId(ideaId);
    }
  };

  const reorderConnector = (ideaId, connector, spaces) => {
    const milestone = connector === 'keyVar' ? 'key' : connector;
    const connectorArray = props.milestones[milestone].connectorIds;
    let newConnectorIds = [];

    newConnectorIds = moveElement(connectorArray, ideaId, spaces);

    props.updateMilestoneConnectorOrderDBOnly(props.journeyId, currentMilestone, newConnectorIds);
  };

  const moveElement = (connectors, connectorId, spaces) => {
    // get current index
    const currentIndex = connectors.findIndex((el) => el === connectorId);
    //
    const newIndex = currentIndex + spaces;
    if (newIndex > connectors.length) {
      // remove element
      connectors.splice(currentIndex, 1);
      // move element to end
      connectors.push(connectorId);
    } else if (newIndex <= 0) {
      // remove element
      connectors.splice(currentIndex, 1);
      // move element to start
      connectors.unshift(connectorId);
    } else {
      // in array bounds shift to the new index
      connectors.splice(newIndex, 0, connectors.splice(currentIndex, 1)[0]);
    }
    
    return connectors;
  };

  const submitIdea = async() => {
    if(content !== '' && editing && content.length < 256) {
      await props.updateIdeaDBOnly(null, ideaId, currentMilestone + 'Connector', content);

      closeAddIdea();
    } else if (content !== '' && content.length < 256) {
      await props.addIdeaDBOnly(props.journeyId, null, currentMilestone + 'Connector', content);

      closeAddIdea();
    } else if (content.length >= 256) {
      props.addToast({ labels: { heading: 'Idea needs to be 255 or less characters.' }, variant: 'error' });
    } else {
      props.addToast({
        labels: {
          heading: 'Please make sure your idea has content.',
        },
        variant: 'error',
      });
    }
  };

  const goToPreviousConnector = () => {
    const idx = milestones.indexOf(currentMilestone);

    if (idx === 1 || idx === 2 || idx === 3) {
      setCurrentMilestone(milestones[idx - 1]);
      setNextMilestone(milestones[idx]);
      setMilestoneStep(milestoneStep - 1);
    } else if (idx === 0) {
      props.history.push('/MilestoneConnectors');
        
      window.location.href = '/Milestones';
    }
  };

  const goToNextConnectors = () => {
    if (Object.keys(props[connectorFormatted[currentMilestone]]).length === 0) {
      props.addToast({
        labels: {
          heading: `Please fill out at least one connection from ${currentMilestone} to ${nextMilestone}.`,
        },
        variant: 'error',
      });
    } else {
      if (currentMilestone === 'crisis') {
        props.setStepId(5);

        props.history.push('/MilestoneConnectors');
        
        window.location.href = '/ProductsOverlay';

        return;
      }
      const idx = milestones.indexOf(currentMilestone);
      if (idx < 3) {
        setCurrentMilestone(milestones[idx + 1]);
        setNextMilestone(milestones[idx + 2]);
        setMilestoneStep(milestoneStep + 1);
      }
    }
  };

  const goToConnector = (event) => {
    if (event.target.getAttribute('data-clickable') === 'true') {
      if (event.target.title === 'trigger') {
        setCurrentMilestone('trigger');
        setNextMilestone('guide');
        setMilestoneStep(1);
      } else if (event.target.title === 'guide') {
        setCurrentMilestone('guide');
        setNextMilestone('key');
        setMilestoneStep(2);
      } else if (event.target.title === 'key') {
        setCurrentMilestone('key');
        setNextMilestone('crisis');
        setMilestoneStep(3);
      } else if (event.target.title === 'crisis') {
        setCurrentMilestone('crisis');
        setNextMilestone('triumph');
        setMilestoneStep(4);
      }
    }
  };

  return (
    <IconSettings iconPath="/icons">
      <CustomToastContainer />
      <div className="outer-container">
        <Sidebar 
          stage="Milestone Connectors"
          instructions={<ConnectorInstructions />}
        />
        <Banner
          backgroundColor='#E1DFF0'
          previous={goToPreviousConnector}
          next={goToNextConnectors}
          stage="Milestone Connectors"
          backgroundImage='/Images/Banners/HeroBanners-03.png'
        />
        <div>
          {/*<SocketListeners /> */}
          <div style={{ marginLeft: 'max(210px, 15%)'}}>
            <div className="slds-p-horizontal_x-large slds-p-vertical_medium">
            <MilestoneConnectorBar
              preMilestone={currentMilestone}
              onMilestoneConnectorClicked={goToConnector}
            />
            <Card 
                heading={
                  <div className="slds-grid">
                    <div className="slds-size_11-of-12">
                      <PageBlockHeader
                        hasBorder={false}
                        title={`Connect: `}
                        addtl={
                          currentMilestone.charAt(0).toUpperCase() + currentMilestone.slice(1) +
                          ' to ' + nextMilestone.charAt(0).toUpperCase() + nextMilestone.slice(1)
                        }
                        subtitle={`Step 1: Create Potential Story Connectors. Step 2: Favorite them to add them to your story.`}
                      />
                    </div>
                    <div className="slds-size_1-of-12">
                      <Button 
                        label="Next Stage" 
                        variant="brand"
                        onClick={goToNextConnectors} 
                        style={{ fontSize: '13px'}}
                      />
                    </div>
                  </div>
                } 
                className="slds-m-top_x-small" 
                >
                <div className="slds-p-horizontal_medium slds-m-top_x-large">
                  <div className="slds-grid slds-gutters slds-m-top_medium">
                    <div className="slds-size_5-of-12 slds-col" style={{ borderRight: '1px dashed #ccc'}}>
                      <ConnectorList
                        currentMilestone={currentMilestone == 'key' ? 'keyVar' : currentMilestone}
                        milestone={currentMilestone}
                        nextMilestone={nextMilestone}
                        milestones={props.milestones}
                        connectors={props.milestoneConnectors}
                        onDropdownSelected={handleDropdownSelect}
                      />
                    </div>
                    <div className="slds-size_7-of-12 slds-col">
                        <PotentialConnectors
                          currentMilestone={currentMilestone}
                          ideas={props.ideas[currentMilestone + 'Connector']}
                          imgPath="/icons/utility/add.svg"
                          color="#f5604d"
                          imgSize="40"
                          border="10px solid white"
                          openEditIdea={openEditIdea}
                          onButtonClick={setIsIdeaOpen}
                          onDropdownSelected={handleIdeaActions}
                        />
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>
        <Modal
          isOpen={isIdeaOpen}
          onRequestClose={closeAddIdea}
        >
          <AddIdea
            milestone={currentMilestone}
            value={content}
            connectors={true}
            onChange={(e) => setContent(e.target.value)}
            onAdd={submitIdea}
            onCancelButtonClick={closeAddIdea}
          />
        </Modal>

        <Modal
          isOpen={isConnectorOpen}
          onRequestClose={setIsConnectorOpen}
        >
          <ConnectorInput
            title={connectorTitle}
            onChangeTitle={(e) => setConnectorTitle(e.target.value)}
            content={connectorContent}
            onChangeContent={(e) => setConnectorContent(e.target.value)}
            milestoneStep={milestoneStep}
            milestone={currentMilestone}
            onAdd={() => { if (connectorContent.length >= 256) { 
                props.addToast({ labels: { heading: 'Connector Content needs to be 255 or less characters.' }, variant: 'error'}); }
              else if (connectorTitle.length >= 256) {
                props.addToast({ labels: { heading: 'Connector Title needs to be 255 or less characters.' }, variant: 'error'});
              } 
              else { handleDropdownSelect(connectorId, "Save", currentMilestone, connectorTitle, connectorContent); }}}
          />
        
        </Modal>
      </div>
    </IconSettings>
  );
}
const mapStateToProps = (state) => ({
  journeyId: state.app.journeyId,
  username: state.app.username,
  milestones: state.milestones,
  milestoneConnectors: state.milestoneConnectors,
  trigger: state.milestoneConnectors.trigger,
  guide: state.milestoneConnectors.guide,
  keyVar: state.milestoneConnectors.keyVar,
  crisis: state.milestoneConnectors.crisis,
  ideas: state.ideas,
});

const mapDispatchToProps = (dispatch) => ({
  addToast: (toast) => dispatch(addToast(toast)),
  setStepId: (stepId) => dispatch(setStepId(stepId)),

  // -- ADD MILESTONE CONNECTOR START --
  addMilestoneConnectorDBOnly: (journeyId, connectorName, title, content) =>
    dispatch(addMilestoneConnectorDBOnly(journeyId, connectorName, title, content)),
  addMilestoneConnector: (journeyId, connectorName, title, content) =>
    dispatch(addMilestoneConnector(journeyId, connectorName, title, content)),
  // -- ADD MILESTONE CONNECTOR END --


  // -- UPDATE MILESTONE CONNECTOR START --
  updateMilestoneConnectorDBOnly: (journeyId, connectorName, title, content) =>
    dispatch(updateMilestoneConnectorDBOnly(journeyId, connectorName, title, content)),
  updateMilestoneConnector: (journeyId, connectorName, title, content) =>
    dispatch(updateMilestoneConnector(journeyId, connectorName, title, content)),
  // -- UPDATE MILESTONE CONNECTOR END --

  // -- DELETE MILESTONE CONNECTOR START --
  deleteMilestoneConnectorDBOnly: (journeyId, connectorName, title, content) =>
    dispatch(deleteMilestoneConnectorDBOnly(journeyId, connectorName, title, content)),
  deleteMilestoneConnector: (journeyId, connectorName, title, content) =>
    dispatch(deleteMilestoneConnector(journeyId, connectorName, title, content)),
  // -- DELETE MILESTONE CONNECTOR END --

  // -- UPDATE MILESTONE CONNECTOR ORDER START --
  updateMilestoneConnectorOrderDBOnly: (journeyId, milestone, connectorIds) =>
    dispatch(updateMilestoneConnectorOrderDBOnly(journeyId, milestone, connectorIds)),
  updateMilestoneConnectorOrder: (milestone, connectorIds) =>
    dispatch(updateMilestoneConnectorOrder(milestone, connectorIds)),
  // -- UPDATE MILESTONE CONNECTOR ORDER END --

  // -- ADD IDEA START --
  addIdeaDBOnly: (journeyId, personaId, stageName, ideaContent) =>
    dispatch(addIdeaDBOnly(journeyId, personaId, stageName, ideaContent)),
  addIdea : (ideaId, personaId, stageName, ideaContent, chosen) =>
    dispatch(addIdea(ideaId, personaId, stageName, ideaContent, chosen)),
  // -- ADD IDEA END -- 

  // -- SELECT IDEA START --
  selectIdeaDBOnly: (journeyId, personaId, stageName, ideaId) =>
    dispatch(selectIdeaDBOnly(journeyId, personaId, stageName, ideaId)),
  selectIdea: (personaId, stageName, ideaId, chosen) =>
    dispatch(selectIdea(personaId, stageName, ideaId, chosen)),
  // -- SELECT IDEA END --

  // -- UPDATE IDEA START -- CERTIFIED
  updateIdeaDBOnly: (personaId, ideaId, stageName, ideaContent) =>
    dispatch(updateIdeaDBOnly(personaId, ideaId, stageName, ideaContent)),
  updateIdea: (personaId, ideaId, stageName, ideaContent) =>
    dispatch(updateIdea(personaId, ideaId, stageName, ideaContent)),
  // -- UPDATE IDEA END --

  // -- DELETE IDEA START --
  deleteIdeaDBOnly: (personaId, stageName, id) =>
    dispatch(deleteIdeaDBOnly(personaId, stageName, id)),
  deleteIdea: (stageName, ideaId) =>
    dispatch(deleteIdea(stageName, ideaId)),
  // -- DELETE IDEA END --
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MilestoneConnectors);
